import { clsx } from 'clsx';
import type { ComponentProps } from 'react';

type IconButtonProps = ComponentProps<'button'> & {
    icon: React.ReactNode;
    ariaLabel?: string;
};

const IconButton = ({ onClick, icon, ariaLabel, className, children, ...props }: IconButtonProps) => {
    return (
        <button
            type="button"
            onClick={onClick}
            aria-label={ariaLabel}
            className={clsx(
                'cursor-pointer rounded-md p-1 transition-colors hover:bg-teal-50 disabled:pointer-events-none disabled:cursor-default disabled:hover:bg-transparent',
                className
            )}
            {...props}
        >
            {icon}
            {children}
        </button>
    );
};

export default IconButton;
